import axios from "axios";

// The public /free page's video (server routes/apis/freeVideoApis.js). Every
// request is `silentError`: the page falls back to its built-in video and the
// settings page shows its own errors.
const SILENT = { silentError: true };

// { fileName, title } or null when nothing was saved yet
export const fetchFreeVideo = () => async () => {
  const response = await axios.get("free-video", SILENT);
  return response.data.video;
};

// Admin: the videos in S3 public/freeVideos/, newest first; `files` is null
// when the server could not list them (`listError` says why)
export const fetchFreeVideoFiles = () => async () => {
  const response = await axios.get("free-video/files", SILENT);
  return response.data;
};

// Admin: { fileName, title, force }. Rejects with a 422 carrying `checks`
// (one per site) when a site's CDN does not serve the file and `force` is off.
export const saveFreeVideo = (settings) => async () => {
  const response = await axios.put("free-video", settings, SILENT);
  return response.data;
};
